import { EditOutlined, SearchOutlined, PrinterOutlined} from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table
} from "antd";


import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import enrollmentService from "../../../api/enrollment.service";


import { Link, useNavigate } from 'react-router-dom';
import { SUCCESS_STATUS } from "../../../utility/Constants";
import ProgrammeService from "../../../api/programme.service";
import CustomTableSearch from "../../common/CustomTableSearch";
import commonUtility from "../../../utility/Utils";
import { PRINT_BASE_URL } from "../../../utility/URL";




const PhysicallFitnessReceiptListComponent = () => {
  let navigate = useNavigate();

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  
  const [selectedProgramme, setSelectedProgramme] = useState(0);
  const [jcpEnrollmentReceiptList, setJcpEnrollmentReceiptList] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);


  const changeLocation = (placeToGo) => {

    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Receipt',
      dataIndex: 'receipt_no',
      key: 'receipt_no',

    },
    {
      title: 'Receipt Date',
      dataIndex: 'receipt_date',
      key: 'receipt_date',
    },
    {
      title: 'Group/Shift',
      dataIndex: 'programme_group',
      key: 'programme_group',
    },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj,record) => (
        <Space>
            <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),

    },
    {
      title: 'Primary Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'DOB',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },
    {
      title: 'Description',
      dataIndex: 'description_list',
      key: 'description_list',
    },
    {
      title: 'Validity',
      dataIndex: 'enrollment_start_date',
      key: 'enrollment_start_date',
      sorter: (a, b) => {
        const nameA = `${a.enrollment_start_date} ${a.enrollment_end_date}`;
        const nameB = `${b.enrollment_start_date} ${b.enrollment_end_date}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj,record) => (
        <Space>
            <span>{record.enrollment_start_date} to {record.enrollment_end_date}</span>
        </Space>
      ),

    },
    {
      title: 'Total Payable',
      dataIndex: 'net_payble_amount',
      key: 'net_payble_amount',
      align: 'right',
      render: (selectedObj,values) => (
        <div align="right">{ commonUtility.sanitizeValue(values.net_payble_amount).toFixed(2)} </div>
      )
    },


    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (

        <Space style={{display:'flex',flexDirection:'column'}}>
         
          <Link to={`/enrollment-pf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
            <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" style={{width:90}}>Edit <EditOutlined /></Button>
          </Link>

          <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
            <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" style={{width:90}}><PrinterOutlined /> Print</Button>
          </a>


        </Space>
      ),
    },
  ];



  useEffect(() => {
    const data = {
      formdata: { short_code: "PF" },
    };
    ProgrammeService.programmeByCode(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSelectedProgramme(res.data.response_data[0].programme_id);
      }
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { programme_id: selectedProgramme }
    }
    enrollmentService.receiptListJCP(data).then((res) => {
      console.log(res.data.response_data);
      setJcpEnrollmentReceiptList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);


      console.log("jcp Receipt List" , res.data.response_data);
    });
  }, [selectedProgramme])


  const editJCPenrollment = (rcno) => {
    console.log("rcno", rcno)
  }



  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    console.log("Clicked", jcpEnrollmentReceiptList);


    const x = jcpEnrollmentReceiptList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);


    setFilteredSearchList(x)
  }


  // useEffect(() => {

  // }, [jcpEnrollmentReceiptList]);


  return (
    <>

      {/* <Form.Item name="search" >
        <Input placeholder="Search ..." size="large" onChange={(e) => onSearch(e)} prefix={<SearchOutlined />} allowClear className="table-search-box" />
      </Form.Item> */}
      <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />

      <Table columns={columns} rowKey='receipt_id' dataSource={filteredSearchList} />



    </>
  );
};

export default PhysicallFitnessReceiptListComponent;